import React from 'react';
import Portfolio from '../../components/Portfolio/Portfolio';

const PortfolioPage: React.FC = () => {
  return (
    <main>
      <Portfolio />
    </main>
  );
};

export default PortfolioPage;